import React from "react";
import { useParams } from "react-router-dom";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import Ticket from "../../../components/Ticket";
import TicketsListPanel from "./TicketsListPanel";
import VisaoDoDia from "./VisaoDoDia";
import { QueueSelectedProvider } from "../../../context/QueuesSelected/QueuesSelectedContext";

// Mesmo breakpoint do shell Novo (layout-new/NewLayout.js,
// MOBILE_BREAKPOINT) - nao exportado de la, repetido aqui como literal
// (nao e' logica, so' o numero do corte).
const MOBILE_BREAKPOINT = "(max-width:900px)";

// Pagina "Atendimentos" do layout Novo (projeto 2026-10-21, ver
// PROMPT.md em D:\voicechat\novo layout). Cobre a tarefa #60 (sem
// ticket aberto -> Visao do dia).
//
// Tarefa #61 (com ticket aberto -> Conversa): decisao explicita do
// usuario foi "reskin seguro", nao reconstrucao - MessagesList e
// MessageInput somados passam de 2700 linhas (audio, emoji, anexos,
// agendamento, notas internas, encaminhar, responder, editar, reacoes)
// e reescrever do zero arriscava derrubar alguma dessas funcoes. Fica
// o componente <Ticket/> classico mesmo, reaproveitado sem mudanca
// nenhuma - ele ja herda boa parte da paleta/raios/bordas do tema Novo
// automaticamente (os Paper dele usam os mesmos overrides do tema). O
// unico ajuste aqui foi tirar o cartao duplo (o <Ticket/> ja' desenha
// seu proprio Paper com borda/raio 16 - um wrapper nosso por fora com
// a mesma borda criava uma moldura dupla que nao existe no mockup).
//
// Mobile (2026-10-22, usuario pediu explicitamente apos notar que a
// tela so' quebrava linha em vez de trocar de tela): replica o mesmo
// padrao "uma tela por vez" que o Classico ja tem (TicketsAdvanced -
// deriva o que mostrar so' de useParams().ticketId, nunca os dois
// paineis juntos). O botao de voltar ja vem de graca - e' o mesmo
// <Ticket/> do Classico, cujo TicketHeader.handleBack ja limpa o
// ticket atual e volta pra "/tickets" sem id. VisaoDoDia some no
// celular quando nao ha' ticket selecionado (so' a lista aparece) -
// no WhatsApp tambem nao existe uma tela de "resumo do dia" entre a
// lista e a conversa.
const NewAtendimentos = () => {
  const { ticketId } = useParams();
  const theme = useTheme();
  const tokens = theme.newLayoutTokens;
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const hasTicket = Boolean(ticketId) && ticketId !== "undefined";

  if (isMobile) {
    return (
      <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
        {hasTicket ? (
          <QueueSelectedProvider>
            <Ticket />
          </QueueSelectedProvider>
        ) : (
          <TicketsListPanel tokens={tokens} selectedUuid={ticketId} fullWidth />
        )}
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 20, alignItems: "stretch", height: "100%" }}>
      <TicketsListPanel tokens={tokens} selectedUuid={ticketId} />
      {hasTicket ? (
        <div
          aria-label="Conversa"
          style={{
            flex: "999 1 480px",
            minWidth: 0,
            height: "100%",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <QueueSelectedProvider>
            <Ticket />
          </QueueSelectedProvider>
        </div>
      ) : (
        <VisaoDoDia tokens={tokens} />
      )}
    </div>
  );
};

export default NewAtendimentos;
